import { isServer } from '../utils';

export const getJsonItem = (key) => {
  const raw = isServer ? null : window.sessionStorage.getItem(key) || null;
  if (raw) {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  } else {
    return null;
  }
};

export const setJsonItem = (key, data) => {
  !isServer && window.sessionStorage.setItem(key, JSON.stringify(data));
};
